import { CSSProperties } from 'react';
import { TextWithLineBreaks } from 'components/common';
import { useReduxState } from 'hooks';

import type { CustomAttributes } from 'shared-types';

interface Props {
  style?: CSSProperties;
  value: CustomAttributes['key'];
}

const AttributeDisplayValue = ({ style, value }: Props) => {
  const { messages } = useReduxState();

  return (
    <div style={style}>
      {Array.isArray(value) ? (
        value.join(', ')
      ) : typeof value === 'boolean' ? (
        value ? (
          messages.commonYes
        ) : (
          messages.commonNo
        )
      ) : typeof value === 'string' && value.includes('\n') ? (
        <TextWithLineBreaks text={value} />
      ) : typeof value === 'number' ? (
        `${value}`
      ) : (
        value || ''
      )}
    </div>
  );
};

export default AttributeDisplayValue;
